import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./1.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 329.4 363.4"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            id="_1A_2105"
            data-name="1A_2105"
            points="108.2 97.6 134.4 97.6 134.4 141 94.6 141 94.6 132.1 107.5 119.1 107.5 97.6 108.2 97.6"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            id="_2B1_2101"
            data-name="2B1_2101"
            points="252.3 97.6 292.3 97.5 292.3 138.6 287 138.6 287 137.1 282.7 137.1 282.7 141 252.3 141 252.3 97.6"
            fill="#231f20"
          />
          <polygon
            id="_2A2_2102"
            data-name="2A2_2102"
            points="213 97.6 252.3 97.6 252.3 141 247 141 247 137.2 242.7 137.2 242.7 141 213 141 213 97.6"
            fill="#231f20"
          />
          <polygon
            id="_2B1_2103"
            data-name="2B1_2103"
            points="173.7 97.6 213 97.6 213 141 207.7 141 207.7 137.1 203.4 137.1 203.4 140.9 173.7 140.9 173.7 97.6"
            fill="#231f20"
          />
          <polygon
            id="_2Ax2_2104"
            data-name="2Ax2_2104"
            points="134.4 97.6 173.7 97.6 173.7 140.9 168.4 140.9 168.4 137.2 164.2 137.2 164.2 141 134.4 141 134.4 97.6"
            fill="#231f20"
          />
          <polygon
            id="_2B1_2106"
            data-name="2B1_2106"
            points="94.6 151.5 106.5 151.5 106.5 156.2 116 156.2 116 198.6 72.6 198.6 72.6 156.7 94.5 156.7 94.6 151.5"
            fill="#231f20"
          />
          <rect
            id="_2Ax2_2107"
            data-name="2Ax2_2107"
            x="72.6"
            y="198.6"
            width="43.4"
            height="39.27"
            fill="#231f20"
          />
          <polygon
            id="_2A1_2108"
            data-name="2A1_2108"
            points="116 277.3 72.7 277.3 72.7 237.9 116 237.9 116 277.3"
            fill="#231f20"
          />
          <rect
            id="_2A2_2109"
            data-name="2A2_2109"
            x="72.7"
            y="277.3"
            width="43.3"
            height="39.92"
            fill="#231f20"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(265.3 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2101
          </text>
          <text
            transform="translate(225.8 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2102
          </text>
          <text
            transform="translate(185.7 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2103
          </text>
          <text
            transform="translate(148.5 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2104
          </text>
          <text
            transform="translate(114.2 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2105
          </text>
          <text
            transform="translate(118.9 179.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2106
            <tspan
              font-size="5.39"
              fill="#a7a9ac"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              <tspan x="0" y="6.5">
                无障碍设施
              </tspan>
            </tspan>
          </text>
          <text
            transform="translate(118.9 223.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2107
          </text>
          <text
            transform="translate(118.9 301.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2109
          </text>
          <text
            transform="translate(118.9 262.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2108
          </text>
          <text
            transform="translate(182.4 213.2)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            <tspan font-weight="700">1</tspan>
            <tspan
              x="5.1"
              y="0"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              楼
            </tspan>
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(265.3 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2101
          </text>
          <text
            transform="translate(225.8 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2102
          </text>
          <text
            transform="translate(185.7 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2103
          </text>
          <text
            transform="translate(148.5 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2104
          </text>
          <text
            transform="translate(114.2 148.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2105
          </text>
          <text
            transform="translate(118.9 179.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2106
            <tspan font-size="5">
              <tspan x="0" y="4">
                для людей с
              </tspan>
              <tspan x="0" y="8">
                ограниченными
              </tspan>
              <tspan x="0" y="12">
                возможностями
              </tspan>
            </tspan>
          </text>
          <text
            transform="translate(118.9 223.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2107
          </text>
          <text
            transform="translate(118.9 301.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2109
          </text>
          <text
            transform="translate(118.9 262.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2108
          </text>
          <text
            transform="translate(174.6 213.2)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            1-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(265.3 148.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2101
          </text>
          <text
            transform="translate(225.8 148.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2102
          </text>
          <text
            transform="translate(185.7 148.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2103
          </text>
          <text
            transform="translate(148.5 148.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2104
          </text>
          <text
            transform="translate(114.2 148.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2105
          </text>
          <text
            transform="translate(118.9 179.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2106
            <tspan x="0" y="7.1">
              Handicap
            </tspan>
          </text>
          <text
            transform="translate(118.9 223.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2107
          </text>
          <text
            transform="translate(118.9 302)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2109
          </text>
          <text
            transform="translate(172.1 213.3)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            1st Floor
          </text>
          <text
            transform="translate(118.9 262.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2108
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/b/1.js